<template>
  <div class="exhibition">
    <MobileHead />
    <div class="loop">
      <loopImg />
    </div>
    <div class="exhibitionContent">
      <div class="main">
        <div class="breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }" class="home">{{ $t('navbar.home') }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t('navbar.exhibition') }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <Screen />
      </div>
    </div>
  </div>
</template>

<script>
import MobileHead from '../../../common/mobile/head.vue';
import loopImg from './components/loopImg.vue';
import Screen from './components/screen.vue';

export default {
  name: '',
  components: { MobileHead, loopImg, Screen },

  data() {
    return {};
  },
  created() {
    document.documentElement.scrollTop = 0;
  },
};
</script>

<style scoped lang="scss">
.exhibition {
  .loop {
    margin-top: 13.3vw;
  }
  .exhibitionContent {
    .main {
      padding-top: 23px;
      box-sizing: border-box;
      margin: 0 auto;
      .breadcrumb {
        padding-left: 4vw;
        box-sizing: border-box;
        a {
          color: #006fb8;
        }
      }
    }
  }
}
</style>
<style scoped>
.breadcrumb >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner{
  color:#006FB8 !important;
  font-family: Microsoft YaHei;
}
.el-breadcrumb__item >>> .el-breadcrumb__inner {
  color: #333 !important;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
</style>